import React, {Component} from 'react';
import {Problem} from './Problem';
import {LearnBox} from "./LearnBox";
import {PointsProgress} from "./PointsProgress";
import {LearnPage} from "./LearnPage";
import {LearnSection} from "./LearnSection";
import {getSubject} from "../services/SubjectService";
import {GameBox} from "./GameBox";

export class Rush extends Component {
    static displayName = Rush.name;

    constructor(props) {
        super(props);
        var initialState = this.getInitialValues();
        var pathParts = window.location.pathname.split("/");
        initialState.subjectKey = pathParts[2];
        initialState.themeKey = pathParts[3];
        initialState.loading = true;
        this.state = initialState;
        this.tryAgain = this.tryAgain.bind(this);
    }

    componentDidMount() {
        this.fetchSubject();
    }

    getInitialValues() {
        return {
            secondsLeft: 2 * 60,
            points: 0,
            started: false,
            streak: 0,
            finished: false
        };
    }

    countDown() {
        var intervalId = setInterval(() => {
            if (this.state.secondsLeft <= 0) {
                clearInterval(intervalId);
                return;
            }
            this.setState({secondsLeft: this.state.secondsLeft - 1},
                () => {
                    if (this.state.secondsLeft <= 0) {
                        this.setState({finished: true});
                    }
                });
        }, 1000);
    }

    handleResult = (event) => {
        if (!this.state.started) {
            this.countDown();
            this.setState({started: true, streak: this.state.streak + 1});
            return;
        }

        var newSecondsLeft = this.state.secondsLeft;
        if (event.correct) {
            var newStreak = this.state.streak + 1;
            if (newStreak > 5) {
                newStreak = 0;
                newSecondsLeft += 20;
            }
            this.setState({points: this.state.points + 1, streak: newStreak, secondsLeft: newSecondsLeft});
        } else {
            newSecondsLeft -= 5;
            this.setState({streak: 0, secondsLeft: Math.max(1, newSecondsLeft)});
        }
    }

    handleNewProblem = (event) => {
        this.setState({});
    }

    tryAgain = () => {
        this.setState(this.getInitialValues());
    }

    render() {
        if (this.state.loading) return <div>Indlæser opgave...</div>;

        let problem = this.state.finished ?
            <div><p>Færdig!</p><input type="button" value="Start igen" onClick={this.tryAgain}/></div> :
            (
                <Problem subjectKey={this.state.subjectKey}
                         themeKey={this.state.themeKey}
                         onResult={this.handleResult}
                         onNewProblem={this.handleNewProblem}
                         mode="streak"/>
            );
        let minutesLeft = Math.floor(this.state.secondsLeft / 60);
        let secondsLeft = this.state.secondsLeft - 60 * minutesLeft;
        const paddedSeconds = (secondsLeft + "").padStart(2, "0");
        return (
            <LearnPage title="Opgave-ræs" backUrl={"/subject/" + this.state.subjectKey}
                       backTitle={this.state.subject.displayName}>
                <LearnSection>
                    <GameBox currentGameText="Rigtige" currentGameNumber={this.state.points}
                             subjectKey={this.state.subjectKey}>
                        {problem}
                    </GameBox>
                    <LearnBox title="Ræs">
                        <p>Rigtige: {this.state.points}</p>
                        <p>{minutesLeft}:{paddedSeconds}</p>
                        <p>Løs den første opgave for at starte tiden.</p>
                        <p>Stime: {this.state.streak}</p>
                    </LearnBox>
                    <LearnBox title="Om Opgave-ræs">
                        <p>Løs så mange opgaver du kan før tiden løber ud!</p>
                        <p>5 rigtige svar i træk giver 20 sekunder ekstra!</p>
                        <p>1 forkert svar koster 5 sekunder!</p>
                    </LearnBox>
                    <LearnBox title="Dagligt mål">
                        <PointsProgress subjectKey={this.state.subjectKey}/>
                    </LearnBox>
                </LearnSection>
            </LearnPage>
        );
    }

    fetchSubject() {
        getSubject(this.state.subjectKey).then(subject => {
            this.setState({subject: subject, loading: false});
        });
    }
}
